import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// import { MenuComponent } from './menu/menu.component';
import { RouterModule } from '@angular/router';
// import { LayoutComponent } from './layout/layout.component';
import { ComponentsModule } from './_components/components.module';
import { AuthGuard } from './_guard/auth.guard';
import { ErrorInterceptor } from './_helpers/error.interceptor';
import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { ComparisonInterceptor } from './_helpers/comparison.interceptor';
import { CustompipeModule } from './_pipes/custompipe.module';
import { GlobalHelper } from './_helpers/global.helper';
import { PoloHelper } from './_helpers/polo.helper';
import { DashCodeHelper } from './_helpers/dashcode.helper';
import { HTTP_INTERCEPTORS } from '@angular/common/http';



@NgModule({
  declarations: [],
  exports: [ComponentsModule,CustompipeModule],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ComponentsModule,
    CustompipeModule
  ],
  providers:[
    ErrorInterceptor,JwtInterceptor,ComparisonInterceptor,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ComparisonInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ],
})
export class SharedModule { }
